import React from 'react';
import {
  Button,
  Divider,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useToast,
} from '@chakra-ui/react';
import {ObjectId} from 'bson';
import {useDeleteApiKey} from '../../../hooks/api/apiKeys';

interface DeleteApiKeyModalProps {
  isOpen: boolean;
  onClose: () => void;
  apiKeyIdToDelete?: ObjectId;
}

export const DeleteApiKeyModal = ({
  isOpen,
  onClose,
  apiKeyIdToDelete,
}: DeleteApiKeyModalProps) => {
  const toast = useToast();
  const deleteApiKey = useDeleteApiKey();

  if (!apiKeyIdToDelete) {
    return null;
  }

  return (
    <Modal isCentered={true} isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader fontWeight="normal" pb="1" pt="6">
          Delete API Key
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody px="6" pt="6" pb="8" color="kgray.300">
          This action can&#39;t be undone.
        </ModalBody>
        <Divider />
        <ModalFooter justifyContent="start" gap="4">
          <Button
            colorScheme="red"
            onClick={() => {
              deleteApiKey.mutate(
                {keyId: apiKeyIdToDelete},
                {
                  onSuccess: () => {
                    toast({
                      status: 'warning',
                      title: 'API key deleted.',
                      duration: 2_000,
                      isClosable: true,
                    });
                  },
                }
              );

              onClose();
            }}
          >
            Delete
          </Button>
          <Button color="kgray.300" onClick={onClose} variant="ghost">
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
